import React from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./../../../assets/images/logonew.png";
import NetworkStatus from "../../../utils/networkStatus";
import { headerData } from "../../../locales/en";
import "./headerdashboard.scss";
import { INVOICE, SIGN_UP } from "../../../route/paths";

const HeaderDemoAccountDashboard = () => {
  const location = useLocation();
  const accessToken = localStorage.getItem("_fundTapAccessToken");

  const handleRemoveDemoAccount = () => {
    localStorage.removeItem("fundTap_demoUser_account_setup");
    localStorage.removeItem("demoInvInfoModalTimestamp");
    localStorage.removeItem("demoInfoModalTimestamp");
  };

  return (
    <>
      <div className="home-header">
        <div className="container">
          <div className="home-header-wrap d-flex justify-content-between align-items-center">
            <div className="logo">
              <Link to={location.pathname}>
                <img src={Logo} alt="logo" />
              </Link>
            </div>
            {accessToken ? (
              <div className="profile-menu demo-profile-menu">
                <Link to={INVOICE} onClick={handleRemoveDemoAccount}>
                  {headerData?.returnToAccount}
                </Link>
              </div>
            ) : (
              <div className="profile-menu demo-profile-menu">
                <Link to={SIGN_UP} onClick={handleRemoveDemoAccount}>
                  {headerData?.setupAccount}
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="blank-height" />
      <NetworkStatus />
    </>
  );
};

export default HeaderDemoAccountDashboard;
